<div class="theme-wrapper" [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.data && o.activatedRoute.routeConfig.data.title">
  <router-outlet #o="outlet"></router-outlet>
</div>
